// 💾 /src/components/EarnCard.tsx
import { getCoinIcon } from "../utils/getCoinIcon"
import "../pages/public/style/Earn.scss"

export type EarnOption = {
  id: number
  type: "staking" | "farming"
  coin?: string
  pair?: string
  apy?: string
  apr?: string
  minLock?: string
  duration?: string
  tvl?: string
}

type Props = {
  option: EarnOption
  index: number
  onInvest: () => void
}

// ⬅️ Move JSX icon rendering here
const renderPairIcons = (pair: string) => {
  const [left, right] = pair.toLowerCase().split("-")
  return (
    <div className="pair-icons">
      <img src={getCoinIcon(left)} alt={left} />
      <img src={getCoinIcon(right)} alt={right} />
    </div>
  )
}

const EarnCard: React.FC<Props> = ({ option, index, onInvest }) => {
  return (
    <div className="earn-card" style={{ ["--i" as any]: index }}>
      {option.type === "staking" ? (
        <img
          src={getCoinIcon(option.coin!)}
          alt={option.coin}
          className="coin-icon"
          onError={(e) => {
            e.currentTarget.src = "https://cryptoicons.cc/icons/generic.png"
          }}
        />
      ) : (
        renderPairIcons(option.pair!)
      )}

      {option.type === "staking" ? (
        <>
          <h3>{option.coin} Staking</h3>
          <p><strong>APY:</strong> {option.apy}</p>
          <p><strong>Min Lock:</strong> {option.minLock}</p>
          <p><strong>Duration:</strong> {option.duration}</p>
        </>
      ) : (
        <>
          <h3>{option.pair} Pool</h3>
          <p><strong>APR:</strong> {option.apr}</p>
          <p><strong>TVL:</strong> {option.tvl}</p>
        </>
      )}

      <button className="stake-button" onClick={onInvest}>
        {option.type === "staking" ? "Stake Now" : "Add Liquidity"}
      </button>
    </div>
  )
}

export default EarnCard
